/**
 * SPDX-FileCopyrightText: 2023 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-only
 */

import { Command } from 'ckeditor5'
export default class InsertItemCommand extends Command {
	/**
	 * @param {module:core/editor/editor~Editor} editor instance
	 * @param {module:engine/model/writer~Writer} writer instance
	 * @param {string} item smart picker or emoji picker
	 * @param {string} trigger the character to replace
	 * @param {int} loopBack the offset to set the corrrect range of the text to replace
	 */
	insertItem(editor, writer, item, trigger, loopBack) {
		const currentPosition = editor.model.document.selection.getLastPosition()
		if (currentPosition === null) {
			// null as current position is probably not possible
			// @TODO Add error to handle such a situation in the callback
			return
		}
		const range = editor.model.createRange(
			currentPosition.getShiftedBy(-loopBack),
			currentPosition,
		)
		// Iterate over all items in this range:
		const walker = range.getWalker({ shallow: false, direction: 'backward' })

		for (const value of walker) {
			if (value.type === 'text' && value.item.data.includes(trigger)) {
				writer.remove(value.item)
				const text = value.item.data
				const lastSlash = text.lastIndexOf(trigger)
				const textElement = writer.createElement('paragraph')
				writer.insertText(text.substring(0, lastSlash), textElement)
				editor.model.insertContent(textElement)

				if (trigger === '@') {
					const mailtoHref = `mailto:${item.email}`
					const anchorText = `@${item.label}`
					const textElement = writer.createText(anchorText, { linkHref: mailtoHref })
					editor.model.insertContent(textElement)
				} else if (trigger === '!') {
					if (item.isHtml) {
						const viewFragment = editor.data.processor.toView(item.content)
						const modelFragment = editor.data.toModel(viewFragment)
						editor.model.insertContent(modelFragment)
					} else {
						const lines = item.content.split('\n')
						const htmlContent = lines.map((line) => `<p>${line}</p>`).join('')
						const viewFragment = editor.data.processor.toView(htmlContent)
						const modelFragment = editor.data.toModel(viewFragment)
						editor.model.insertContent(modelFragment)
					}
				} else {
					const itemElement = writer.createElement('paragraph')
					writer.insertText(item, itemElement)
					editor.model.insertContent(itemElement)
				}

				return
			}
		}

		// @TODO If we end up here, we did not find the slash. We should throw an error maybe.
	}

	/**
	 * @param {string}  item link from smart picker or emoji from emoji picker
	 * @param {string} trigger the character to replace
	 * @param {int} loopBack the offset to set the corrrect range of the text to replace defaults to 5
	 */
	execute(item, trigger, loopBack = 5) {
		this.editor.model.change((writer) => {
			this.insertItem(this.editor, writer, item, trigger, loopBack)
		})
	}

	refresh() {
		this.isEnabled = true
	}
}
